import log from 'loglevel';
import * as React from 'react';
import { connect } from 'react-redux';
import { Set } from 'immutable';
import { setAuthtoken as setAuthtokenAction } from '../../store/actions';
import { config as configSelectors } from '../../store/selectors';

type ReduxState = any;
type MaybeAuthtoken = string | undefined;

export type GetToken = () => Promise<MaybeAuthtoken>;
export type InvalidateToken = () => Promise<void>;

export interface AuthtokenManagerProps {
    getToken: GetToken;
    getTokenIntervalMs: number;
    invalidateToken: InvalidateToken;
}

interface StateProps {
    authtoken: MaybeAuthtoken;
}

interface DispatchProps {
    setAuthtoken: (authtoken: MaybeAuthtoken) => void;
}

type AllProps = AuthtokenManagerProps & StateProps & DispatchProps;

const AuthtokenManager: React.FC<AllProps> = ({
    getToken,
    getTokenIntervalMs,
    invalidateToken,
    authtoken,
    setAuthtoken,
}: AllProps) => {
    React.useEffect(() => {
        if (getToken && getTokenIntervalMs && getTokenIntervalMs > 0) {
            getToken().then((token) => setAuthtoken(token));

            const interval = setInterval(() => {
                getToken().then((token) => setAuthtoken(token));
            }, getTokenIntervalMs);

            return () => clearInterval(interval);
        }
    }, [getToken, getTokenIntervalMs, setAuthtoken]);

    return null;
};

const mapStateToProps = (state: ReduxState, ownProps: AuthtokenManagerProps): StateProps => {
    return {
        authtoken: configSelectors.authtoken(state?.config),
    };
};

const mapDispatchToProps = (
    dispatch: React.Dispatch<any>,
    ownProps: AuthtokenManagerProps
): DispatchProps => {
    return {
        setAuthtoken: (authtoken: MaybeAuthtoken) => dispatch(setAuthtokenAction(authtoken)),
    };
};

export default connect<StateProps, DispatchProps, AuthtokenManagerProps>(
    mapStateToProps,
    mapDispatchToProps
)(AuthtokenManager);
